export default __webpack_public_path__ + "static/tower-of-hanoi-b9cd122856aa0ec92483584ee22cd784.gif";